"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCKET_EVENT = void 0;
exports.SOCKET_EVENT = {
    CONNECT: "connect",
    CONNECT_ERROR: "connect-error",
    CONNECT_TIMEOUT: "connect_timeout",
    PONG: "pong",
    DISCONNECT: "disconnect",
    RECONNECT: "reconnect",
    RECONNECT_ATTEMPT: "reconnect_attempt",
    RECONNECT_ERROR: "reconnect_error",
    RECONNECT_FAILED: "reconnect_failed",
    AUTHENTICATION: "authentication",
    AUTHENTICATED: "authenticated",
    UNAUTHORIZED: "unauthorized",
    CONNECTION_ESTABLISHED: "connection-established",
    SEND_MESSAGE: "send-message",
    EDIT_MESSAGE: "edit-message",
    DELETE_MESSAGE: "delete-message",
    MESSAGE_DELETE: "v2-message-deleted",
    CHAT_MESSAGE: "chat-message",
    MESSAGE_UPDATE: "message-updated",
    ACKNOWLEDGE_MESSAGE: `acknowledge-message`,
    MESSAGE_ACKNOWLEDGE: `message-acknowledged`,
    VISIBLE_TO_PATIENT_PHYSICIAN: "visible-to-patient-physician",
    EXPORT_CHAT: `export-file-update`,
    NEW_ALERT: "new-alert", // priority / referral add
    V2_NEW_ALERT: "v2-new-alert", //priority,
    REMOVE_ALERT: "alert-remove", // priority / referral send
    V2_REMOVE_ALERT: "v2-alert-remove", // ACK read  remove
    ALERT_UPDATE: "alert-update",
    MARK_AS_READ: "mark-as-read",
    MESSAGE_READ: `message-read`,
    MARK_AS_DELIVERED: "mark-as-delivered",
    MESSAGE_DELIVERED: `message-delivered`,
    FORWARD_MESSAGE: `forward-message`,
    ASK_FOR_ACKNOWLEDGEMENT: `ask-for-acknowledgement`,
    USER_UPDATE: "user-update",
    // GROUP_UPDATE: "group-update",
    GROUP_UPDATE: "v2-group-update",
    GROUP_SETTING_UPDATE: "group-settings-update",
    NEW_CHAT: "new-chat",
    GROUP_LEFT: `left-group`,
    HIDE_CHAT: "hide-chat",
    UNHIDE_CHAT: "unhide-chat",
    CHAT_DELETED: `chat-deleted`,
    ADD_TO_GROUP: "added-to-group",
    USER_REMOVE_FROM_GROUP: `user-removed-from-group`,
    USER_ADD_TO_GROUP: "user-added-to-group",
    NO_PENDING_ACKNOWLEDGE: "no-pending-acknowledgement",
    START_CALL: "start-call",
    JOIN_CALL: "join-call",
    END_CALL: "end-call",
    ADD_TO_CALL: "add-to-call",
    DISCONNECT_CALL: "disconnect-call",
    REJECT_CALL: "reject-call",
    ON_ONOTHER_CALL: "on-another-call",
    INCOMING_CALL: "incoming-call",
    CALL_NOT_ANSWERED: "call-not-answered",
    CALL_STATUS: "call-status-check",
    PING_CHECK: `ping-check`,
    USER_ONLINE: `user-online`,
    USER_OFFLINE: `user-offline`,
    GET_MEDIA_SIGNED_URL: `get-media-signed-url`,
    ACTION_ON_REMINDER: `action-on-reminder`,
    NEW_SENT_ACKNOWLEDGEMENT: "new-sent-acknowledgement",
    CHAT_LOG_UPDATE: "chat-log-update",
};
